export const MAX_ACTIVE_PROJET_AUDIT = 3;
export const MAX_PHOTO_POINT_AUDIT_NC = 5;
export const MAX_PHOTO_ANOMALIE_AUDIT_NC = 5;
